import React from "react"
import { connect } from "react-redux"

import Calendar from "search-new/components/Visualization/Calendar/index"

import * as sharedSelectors from 'shared/search/selectors'
import * as webSelectors from 'search-new/selectors'

import {
    registerVisualization,
    loadVisualizationData,
    updateExtraVisualizationData,
} from 'search-new/action-creators'

const mapStateToProps = (state, props) => ({
    data: webSelectors.selectVisualizationData(state, props),
    currentFilters: sharedSelectors.selectAllActiveDeserializedFilters(state, props),
    visualizationFilterValues: webSelectors.selectVisualizationFilterValues(state, props),
    visualizationFilterKeys: webSelectors.selectVisualizationFilterKeys(state, props),
    isVisualizationRegistered: webSelectors.selectIsVisualizationRegistered(state, props),
    isVisualizationLoading: webSelectors.selectIsVisualizationLoading(state, props),
    isVisualizationDataEmpty: webSelectors.selectIsVisualizationDataEmpty(state, props),
    calendarDateRange: webSelectors.selectCalendarDateRange(state, props),
})

const actions = {
    registerVisualization,
    loadVisualizationData,
    updateExtraVisualizationData,
}

export default connect(mapStateToProps, actions)(Calendar)
